/** @jsx isolateComponent */

import { useState } from 'react';

import { isolateComponent } from '@zapier/style-encapsulation';

import { useAutoUpgrade, useIsAuthenticated } from '@zapier/upsells/src/hooks';
import { getAutoUpgradeFromUrl } from '../DirectLinkAutoUpgradeModal/getAutoUpgradeFromUrl';
import { AutoUpgradeModal } from '../AutoUpgradeModal';

const HAS_SEEN_LOGIN_AUTO_UPGRADE_MODAL = 'hasSeenLoginAutoUpgradeModal';

export const LoginAutoUpgradeModal = () => {
  const { isAuthenticated } = useIsAuthenticated();
  return isAuthenticated ? <LoginAutoUpgradeModalAuthed /> : null;
};

export const LoginAutoUpgradeModalAuthed = () => {
  const {
    isAutoUpgradeEnabled,
    isEligibleForAutoUpgrade,
    isLoading,
  } = useAutoUpgrade();

  const hasSeenLoginAutoUpgradeModal =
    localStorage.getItem(HAS_SEEN_LOGIN_AUTO_UPGRADE_MODAL) === 'true';

  const shouldShowModal =
    isEligibleForAutoUpgrade &&
    !isAutoUpgradeEnabled &&
    !hasSeenLoginAutoUpgradeModal &&
    !getAutoUpgradeFromUrl(); // Prevents duplicate modal from showing when user has direct linked to the auto upgrade modal

  return !isLoading ? (
    <LoginAutoUpgradeModalStateful shouldShowModal={shouldShowModal} />
  ) : null;
};

type StatefulProps = {
  shouldShowModal: boolean;
};

const LoginAutoUpgradeModalStateful = ({ shouldShowModal }: StatefulProps) => {
  const setHasSeenLoginAutoUpgradeModal = (value: boolean) =>
    localStorage.setItem(HAS_SEEN_LOGIN_AUTO_UPGRADE_MODAL, value.toString());

  const [isModalVisible, setIsModalVisible] = useState(shouldShowModal);

  const onClose = () => {
    setHasSeenLoginAutoUpgradeModal(true);
    setIsModalVisible(false);
  };

  if (!isModalVisible) {
    return null;
  }

  return <AutoUpgradeModal onClose={onClose} />;
};
